import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Document, Page } from 'react-pdf'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'

import './PDFAgreement.css'

class PDFAgreement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pageNumber: null,
      numPages: null,
      pageWidth: 100,
    }
    this.rootRef = React.createRef()
  }

  confirmRequirement() {
    if (!this.props.onAgree) {
      return;
    }
    this.props.onAgree()
  }

  render() {
    const { requirement, confirmed } = this.props
    return <div className='PDFAgreementRoot' ref={this.rootRef}>
      <Document
        file={requirement.src}
        onLoadSuccess={({ numPages }) => this.setState({
          numPages,
          pageNumber: 1,
          pageWidth: this.rootRef.current.clientWidth,
        })}
      >
        <Page
          className='PDFAgreementDocument'
          pageNumber={this.state.pageNumber}
          width={this.state.pageWidth}
        />
      </Document>
      {this.state.numPages && <div className='PDFAgreementPages'>
          <FontAwesomeIcon
            className='PDFPageControl PDFPagePrevious'
            onClick={() => this.setState({
              pageNumber: Math.max(this.state.pageNumber - 1, 1),
            })}
            icon={faAngleLeft}
          />
          {this.state.pageNumber} / {this.state.numPages}
          <FontAwesomeIcon
            className='PDFPageControl PDFPageNext'
            onClick={() => this.setState({
              pageNumber: Math.min(this.state.pageNumber + 1, this.state.numPages),
            })}
            icon={faAngleRight}
          />
        </div>}
      <div className='PDFAgreementControls'>
        {confirmed && <div className='PDFAgreementAgreed'>
            確認済みです。
          </div>}
        {!confirmed && <Row className='PDFAgreementControlsRow'>
            <Col sm={10}>
              説明を確認したら、「確認した」ボタンを押してください。
            </Col>
            <Col sm='auto'>
              <Button
                data-test-pdf-agreement-confirm
                variant='success'
                onClick={() => this.confirmRequirement()}
              >
                確認した
              </Button>
            </Col>
          </Row>}
      </div>
    </div>
  }
}

export default PDFAgreement;
